/**
 * Pure formatting for the per-tile freshness line ("Updated 2m ago · 45 ms").
 * Coarse buckets on purpose — the footer re-renders on a slow tick, so
 * second-precision would visibly stick between ticks.
 */

/** "just now" (<45s) → "Nm ago" → "Nh ago" → "Nd ago". '' for unparseable. */
export const formatRelativeTime = (isoTimestamp: string, nowMs: number): string => {
  const then = Date.parse(isoTimestamp);
  if (!Number.isFinite(then)) return '';
  const seconds = Math.max(0, Math.floor((nowMs - then) / 1000));
  if (seconds < 45) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${Math.max(1, minutes)}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

/** "45 ms" under a second, "1.2 s" under ten, "42 s" beyond. */
export const formatRunDuration = (durationMs: number): string => {
  const ms = Math.max(0, Math.round(durationMs));
  if (ms < 1000) return `${ms} ms`;
  const seconds = ms / 1000;
  return seconds < 10 ? `${seconds.toFixed(1)} s` : `${Math.round(seconds)} s`;
};
